import { defineBlocksWithJsonArray } from 'blockly/core';

import { registerBeginnerFields } from './beginner/fields/register-fields.js';
import { getBeginnerLedPinOptions } from './beginner/helpers/block-builders.js';
import { registerBeginnerDisplayBlocks } from './beginner/display/register-display-blocks.js';
import { registerBeginnerLedBlocks } from './beginner/led/register-led-blocks.js';
import { registerBeginnerLoopBlocks } from './beginner/loops/register-loop-blocks.js';
import { registerBeginnerMathBlocks } from './beginner/math/register-math-blocks.js';
import { registerBeginnerSerialMonitorBlocks } from './beginner/serial/register-serial-blocks.js';
import { registerBeginnerSoundBlocks } from './beginner/sound/register-sound-blocks.js';
import { registerBeginnerSwitchBlocks } from './beginner/switch/register-switch-blocks.js';
import { registerBeginnerTimeBlocks } from './beginner/time/register-time-blocks.js';

const beginnerBlockDefinitions = [
  {
    type: 'beginner_start',
    message0: 'Start %1',
    args0: [{ type: 'input_statement', name: 'STACK' }],
    style: 'beginner_hat_blocks',
    tooltip: 'Runs the blocks inside when the program starts.',
    helpUrl: '',
  },
  {
    type: 'beginner_forever',
    message0: 'forever %1',
    args0: [{ type: 'input_statement', name: 'DO' }],
    previousStatement: null,
    nextStatement: null,
    style: 'loop_blocks',
    tooltip: 'Repeats the blocks inside forever.',
    helpUrl: '',
  },
  {
    type: 'beginner_wait',
    message0: 'wait %1 seconds',
    args0: [{ type: 'field_number', name: 'SECONDS', value: 1, min: 0 }],
    previousStatement: null,
    nextStatement: null,
    style: 'beginner_time_blocks',
    tooltip: 'Pauses the program for a number of seconds.',
    helpUrl: '',
  },
  {
    type: 'beginner_led_on',
    message0: 'built in LED on',
    previousStatement: null,
    nextStatement: null,
    style: 'beginner_led_blocks',
    tooltip: 'Turns the built-in LED on.',
    helpUrl: '',
  },
  {
    type: 'beginner_led_off',
    message0: 'built in LED off',
    previousStatement: null,
    nextStatement: null,
    style: 'beginner_led_blocks',
    tooltip: 'Turns the built-in LED off.',
    helpUrl: '',
  },
  {
    type: 'beginner_blink_led',
    message0: 'blink LED on pin %1 every %2 seconds',
    args0: [
      {
        type: 'field_dropdown',
        name: 'PIN',
        options: getBeginnerLedPinOptions,
      },
      { type: 'field_number', name: 'SECONDS', value: 1, min: 0.1 },
    ],
    previousStatement: null,
    nextStatement: null,
    style: 'beginner_led_blocks',
    tooltip: 'Blinks the LED on and off repeatedly.',
    helpUrl: '',
  },
  {
    type: 'beginner_button_pressed',
    message0: 'switch pressed?',
    output: 'Boolean',
    style: 'beginner_switch_blocks',
    tooltip: 'True when the switch is pressed.',
    helpUrl: '',
  },
  {
    type: 'beginner_buzzer',
    message0: 'play sound',
    previousStatement: null,
    nextStatement: null,
    style: 'beginner_sound_blocks',
    tooltip: 'Plays a sound.',
    helpUrl: '',
  },
  {
    type: 'beginner_display_text',
    message0: 'display text %1',
    args0: [{ type: 'field_input', name: 'TEXT', text: 'Hello' }],
    previousStatement: null,
    nextStatement: null,
    style: 'beginner_display_blocks',
    tooltip: 'Shows text on the display.',
    helpUrl: '',
  },
];

export function registerBeginnerBlocks(): void {
  registerBeginnerFields();
  defineBlocksWithJsonArray(beginnerBlockDefinitions);
  registerBeginnerLedBlocks();
  registerBeginnerSwitchBlocks();
  registerBeginnerSoundBlocks();
  registerBeginnerDisplayBlocks();
  registerBeginnerSerialMonitorBlocks();
  registerBeginnerTimeBlocks();
  registerBeginnerLoopBlocks();
  registerBeginnerMathBlocks();
}
